import i18next, { ThirdPartyModule } from 'i18next'
import { initReactI18next } from 'react-i18next'

// plug-core installs it's own version of react-i18next which also has to be initialized
export const initializeI18n = (
  initReactI18n: ThirdPartyModule,
  translations: object,
  intializeCoreI18n = true
) => {
  if (intializeCoreI18n) {
    initializeI18n(initReactI18next, translations, false)
  }

  i18next.use(initReactI18n).init({
    resources: {
      en: { translation: { ...translations } },
    },
    lng: 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  })
}
